module.exports = "../../../../platform/assets/pageMainIcon/industry_jichudanganlei2.svg";